var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['dropdown', _vm.isOpen ? 'dropdown--open' : ''],on:{"click":_vm.open}},[_vm._t("button"),_vm._v(" "),_vm._t("submenu")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }